<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br/>
            <!--ข้อมูลลูกค้า--->
            <h4 style="padding-left: 20px">ข้อมูลลูกค้า</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ลูกค้าพิเศษ (กรณี ลูกค้าปลาทู)
                        </label>
                        <div class="col-sm-6 form-check-inline">
                            <div class="form-check">
                                <input class="form-check-input" id="special_customer_yes"
                                       type="radio"
                                       v-model="form.special_customer" value="1">
                                <label class="form-check-label" for="special_customer_yes">ใช่</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" id="special_customer_no"
                                       type="radio"
                                       v-model="form.special_customer" value="0">
                                <label class="form-check-label" for="special_customer_no">ไม่ใช่</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            แบนโปรโมชั่น
                        </label>
                        <div class="col-sm-6 form-check-inline">
                            <div class="form-check">
                                <input class="form-check-input" id="ban_promotion_yes"
                                       type="radio"
                                       v-model="form.ban_promotion" value="1">
                                <label class="form-check-label" for="ban_promotion_yes">ใช่</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" id="ban_promotion_no"
                                       type="radio"
                                       v-model="form.ban_promotion" value="0">
                                <label class="form-check-label" for="ban_promotion_no">ไม่ใช่</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสลูกค้า
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   disabled v-model="form.customer_id"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อร้าน
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.store_name"
                                   v-on:change="generateCustomerID()"/>
                        </div>
                        <br/>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 1
                        </label>
                        <div class="col-sm-6">
                            <masked-input class="form-control"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          type="tel"
                                          v-model="form.phone"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 2
                        </label>
                        <div class="col-sm-6">
                            <masked-input class="form-control"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          type="tel"
                                          v-model="form.phone2"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เบอร์โทรศัพท์ 3
                        </label>
                        <div class="col-sm-6">
                            <masked-input class="form-control"
                                          mask="111-111-1111"
                                          placeholder="เบอร์โทรศัพท์"
                                          type="tel"
                                          v-model="form.phone3"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เซลล์
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                :customLabel="customLabel"
                                :options="OptionSeller"
                                :show-labels="false"
                                placeholder="กรุณาเลือกเซลล์"
                                track-by="sale_id"
                                v-model="form.sale"
                                v-on:input="generateCustomerID()">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เครดิตลิมิต
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   type="number"
                                   v-model="form.credit_limit"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ชื่อ
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.first_name"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            นามสกุล
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.last_name"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            อีเมลล์
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   v-model="form.email"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เลขประจำตัวผู้เสียภาษี(ถ้ามี)
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control" v-model="form.tax_number"/>
                        </div>
                        <br/>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            อัพโหลดไฟล์ (PDF)
                        </label>
                        <div class="col-sm-6">
                            <b-form-file
                                @change="fileUpload"
                                placeholder="Choose a file..."
                                ref="file">
                            </b-form-file>
                        </div>
                    </div>
                    <div class="form-group row" v-if="form.file && typeof(form.file)!= 'object' ">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                        </label>
                        <div class="col-sm-6">
                            <a :href="form.file" style="color: red" target="_blank">
                                <icon name="file-pdf"></icon>
                                ดูไฟล์ (PDF) ใบเสนอราคาจากลูกค้า
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <!--ข้อมูลที่อยู่-->
            <h4 style="padding-left: 20px">ข้อมูลที่อยู่</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <h5 class="col-sm-12" style="padding-left: 20px">ที่อยู่สำหรับจัดส่ง</h5>
                <div class="col-sm-12">
                    <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-capitalize text-right">
                            รายละเอียดที่อยู่
                        </label>
                        <div class="col-sm-9">
                            <textarea class="form-control" v-model="form.address"/>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            จังหวัด
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                :options="optionProvince"
                                :show-labels="false"
                                @input="getDistricts(form.province)"
                                label="name"
                                placeholder="เลือกจังหวัด"
                                track-by="name"
                                v-model="form.province">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            แขวง / ตำบล
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                :options="optionSubDistricts"
                                :show-labels="false"
                                label="name"
                                placeholder="เลือกแขวง / ตำบล"
                                track-by="name"
                                v-model="form.sub_district">
                            </multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            เขต / อำเภอ
                        </label>
                        <div class="col-sm-6">
                            <multiselect
                                :options="optionDistricts"
                                :show-labels="false"
                                @input="getSubDistricts(form.district)"
                                label="name"
                                placeholder="เลือกเขต / อำเภอ"
                                track-by="name"
                                v-model="form.district">
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            รหัสไปรษณีย์
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control" readonly v-model="post_code"/>
                        </div>
                    </div>
                </div>
                <!--ที่อยู่สำหรับออกใบกำกับภาษี-->
                <h5 class="col-sm-12 pt-3" style="padding-left: 20px">ที่อยู่สำหรับออกใบกำกับภาษี</h5>
                <div class="col-sm-12 pl-sm-0 pl-5">
                    <div class="form-group row">
                        <label class="offset-sm-1 col-sm-3 col-form-label text-capitalize">
                            <input checked
                                   name="status"
                                   type="radio"
                                   v-model="form.have_new_address"
                                   value="1"/>
                            &nbsp;ที่อยู่เดียวกับจัดส่ง
                        </label>
                        <label class="col-sm-3 col-form-label text-capitalize">
                            <input name="status"
                                   type="radio"
                                   v-model="form.have_new_address"
                                   value="2"/>
                            ที่อยู่ใหม่
                        </label>
                    </div>
                </div>
                <template v-if="form.have_new_address == 2">
                    <!---address_tax_1----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_1" type="radio"
                                   v-model="form.display_address_tax"
                                   value="1"/>
                            <label for="address_tax_1">ที่อยู่ออกใบกำกับภาษี 1</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    ชื่อ
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_1.tax_name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขประจำตัวผู้เสียภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_1.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"
                                              v-model="form.address_tax_1.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        :show-labels="false"
                                        @input="getDistrictsTax(1)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        track-by="name"
                                        v-model="form.address_tax_1.province">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        :show-labels="false"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        track-by="name"
                                        v-model="form.address_tax_1.sub_district">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionDistrictTaxAddress"
                                        :show-labels="false"
                                        @input="getSubDistrictsTax(1)"
                                        label="name"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name"
                                        v-model="form.address_tax_1.district">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           readonly v-model="post_code1"/>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!---address_tax_2----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_2" type="radio" v-model="form.display_address_tax" value="2"/>
                            <label for="address_tax_2">ที่อยู่ออกใบกำกับภาษี 2</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    ชื่อ
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_2.tax_name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขประจำตัวผู้เสียภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_2.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="form.address_tax_2.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        :show-labels="false"
                                        @input="getDistrictsTax(2)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        track-by="name"
                                        v-model="form.address_tax_2.province">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        :show-labels="false"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        track-by="name"
                                        v-model="form.address_tax_2.sub_district">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionDistrictTaxAddress"
                                        :show-labels="false"
                                        @input="getSubDistrictsTax(2)"
                                        label="name"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name"
                                        v-model="form.address_tax_2.district">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           readonly v-model="post_code2"/>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!---address_tax_3----->
                    <template>
                        <h6 class="font-weight-bold pl-5">
                            <input id="address_tax_3" type="radio" v-model="form.display_address_tax" value="3"/>
                            <label for="address_tax_3">ที่อยู่ออกใบกำกับภาษี 3</label>
                        </h6>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    ชื่อ
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_3.tax_name"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    เลขประจำตัวผู้เสียภาษี
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control" v-model="form.address_tax_3.tax_number"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="form-group row">
                                <label class="col-sm-2 col-form-label text-capitalize text-right">
                                    รายละเอียดที่อยู่
                                </label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="form.address_tax_3.address"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    จังหวัด
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionProvinceTaxAddress"
                                        :show-labels="false"
                                        @input="getDistrictsTax(3)"
                                        label="name"
                                        placeholder="เลือกจังหวัด"
                                        track-by="name"
                                        v-model="form.address_tax_3.province">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    แขวง / ตำบล
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionSubDistrictTaxAddress"
                                        :show-labels="false"
                                        label="name"
                                        placeholder="เลือกแขวง / ตำบล"
                                        track-by="name"
                                        v-model="form.address_tax_3.sub_district">
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    เขต / อำเภอ
                                </label>
                                <div class="col-sm-6">
                                    <multiselect
                                        :options="optionDistrictTaxAddress"
                                        :show-labels="false"
                                        @input="getSubDistrictsTax(3)"
                                        label="name"
                                        placeholder="เลือกเขต / อำเภอ"
                                        track-by="name"
                                        v-model="form.address_tax_3.district">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label text-capitalize text-right">
                                    รหัสไปรษณีย์
                                </label>
                                <div class="col-sm-6">
                                    <input class="form-control"
                                           readonly v-model="post_code3"/>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <br/>
            <!--ค่าเที่ยว-->
            <h4 style="padding-left: 20px">ค่าเที่ยว</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="col-sm-6">
                    <div class="form-group row" v-for="data in newList">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ค่าเที่ยว{{ data.name }}
                        </label>
                        <div class="col-sm-6">
                            <input class="form-control"
                                   type="number"
                                   v-model="data.fee"/>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label text-capitalize text-right">
                            ระยะทาง
                        </label>
                        <div class="col-sm-5 col-9">
                            <input class="form-control"
                                   placeholder="เช่น 30 กม."
                                   type="number"
                                   v-model="form.distance"/>
                        </div>
                        <label class="col-1 col-form-label text-capitalize ">
                            กม.
                        </label>
                    </div>
                </div>
            </div>
            <br/>
            <!--ค่าขนส่ง-->
            <h4 style="padding-left: 20px">ค่าขนส่ง</h4>
            <div class="row border border-dark" style="margin: 15px;padding: 20px">
                <div class="row form-group">
                    <div class="form-check" style="margin: 10px">
                        <input class="form-check-input" id="defaultCheck1" type="radio"
                               v-model="form.fixed_rate_status"
                               value="1">
                        <label class="form-check-label" for="defaultCheck1">
                            ค่าขนส่งต่อห่อ
                        </label>
                    </div>
                    <div class="form-check" style="margin: 10px">
                        <input class="form-check-input" id="defaultCheck2" type="radio"
                               v-model="form.fixed_rate_status"
                               value="2">
                        <label class="form-check-label" for="defaultCheck2">
                            ค่าขนส่งแบบเหมา
                        </label>
                    </div>
                </div>
                <div class="row container-fluid" v-if="form.fixed_rate_status">
                    <table class="table table-borderless " style="text-align: center">
                        <thead>
                        <tr>
                            <th scope="col"></th>
                            <template v-for="transport in optionTransportType">
                                <th scope="col" v-if="transport.id != optionTransportType.length">{{ transport.name }}
                                </th>
                            </template>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="transport in TransportForm">
                            <td style="text-align: right">{{ transport[0].transport_wrap_name }}</td>
                            <td v-for="item in transport" v-if="item.transport_type_id != 4">
                                <input
                                    :disabled="(form.fixed_rate_status == 1 && item.transport_type_wrap_id == 1) || (form.fixed_rate_status == 2 && item.transport_type_wrap_id != 1)"
                                    class="form-control"
                                    type="number"
                                    v-model="item.price"/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br/>
            <!--ลูกค้ารายย่อย--->
            <h4 style="padding-left: 20px">รายละเอียดลูกค้ารายย่อย</h4>
            <template v-for="(data,index) in customer_other">
                <div class="row border border-dark" style="margin: 15px;padding: 20px">
                    <div class="col-sm-6">
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ชื่อร้าน / ชื่อลูกค้า
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       type="text"
                                       v-model="data.store_name"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เบอร์โทรศัพท์
                            </label>
                            <div class="col-sm-6">
                                <masked-input class="form-control"
                                              mask="111-111-1111"
                                              placeholder="เบอร์โทรศัพท์"
                                              type="tel"
                                              v-model="data.phone"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ที่อยู่โดยละเอียด
                            </label>
                            <div class="col-sm-6">
                                <textarea class="form-control" v-model="data.address"></textarea>
                            </div>
                        </div>
                        <!--ค่าเที่ยวลูกค้ารายย่อย-->
                        <div class="row form-group">
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" v-model="data.status_transport_driver"
                                       value="1">
                                <label class="form-check-label">
                                    ค่าเที่ยวเดิม
                                </label>
                            </div>
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" v-model="data.status_transport_driver"
                                       value="2">
                                <label class="form-check-label">
                                    ค่าเที่ยวใหม่
                                </label>
                            </div>
                        </div>
                        <div class="row form-group">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ระยะทาง
                            </label>
                            <div class="col-sm-5 col-9">
                                <input class="form-control"
                                       placeholder="เช่น 30 กม."
                                       type="number"
                                       v-model="data.distance"/>
                            </div>
                            <label class="col-1 col-form-label text-capitalize ">
                                กม.
                            </label>
                        </div>
                        <div class="form-group row" v-for="transport in data.transport_price"
                             v-if="data.transport_id != data.transport_price.length">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ค่าเที่ยว{{ transport.name }}
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       type="number"
                                       v-model="transport.fee"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6" style="border-left: 1px solid black">
                        <div class="form-group row float-right">
                            <div class="float-right" style="margin: 15px; text-align: left;">
                                <button @click="removeCustomerOther(index)" class="btn btn-outline-danger"
                                        type="button">
                                    <icon name="times"></icon>
                                    ลบข้อมูล
                                </button>
                            </div>
                        </div>
                        <br>
                        <!--ค่าขนส่งลูกค้ารายย่อย-->
                        <div class="row form-group">
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" v-model="data.status_transport_form"
                                       value="1">
                                <label class="form-check-label">
                                    ค่าขนส่งต่อห่อ
                                </label>
                            </div>
                            <div class="form-check" style="margin: 10px">
                                <input class="form-check-input" type="radio" v-model="data.status_transport_form"
                                       value="2">
                                <label class="form-check-label">
                                    ค่าขนส่งแบบเหมา
                                </label>
                            </div>
                        </div>
                        <div class="row container-fluid">
                            <table class="table table-borderless " style="text-align: center">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <template v-for="transport in optionTransportType">
                                        <th scope="col" v-if="transport.id != optionTransportType.length">
                                            {{ transport.name }}
                                        </th>
                                    </template>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="transport in data.transport_form">
                                    <td style="text-align: right">{{ transport[0].transport_wrap_name }}</td>
                                    <td v-for="item in transport" v-if="item.transport_type_id != 4">
                                        <input class="form-control"
                                               type="number"
                                               v-model="item.price"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
            <div class="row">
                <div class="row" style="margin-left: 15px;padding-left: 20px">
                    <button @click="addCustomerOther"
                            class="btn btn-outline-primary"> + เพิ่มรายการลูกค้ารายย่อย
                    </button>
                </div>
            </div>
            <br>
            <!--save--->
            <div class="mt-4 col text-center" v-if="canViewSuperAdmin">
                <button @click="saveCustomerData"
                        class="btn btn-success"
                        type="button">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button @click="goToCustomerList"
                        class="btn btn-outline-secondary"
                        type="button">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
                &nbsp&nbsp
                <button @click="showModalDelete(form.id)"
                        class="btn btn-danger"
                        type="button"
                        v-if="id">
                    <icon name="trash"></icon>
                    ลบ
                </button>
            </div>
            <br>
            <!--b-modal delete-->
            <b-modal hide-footer hide-header ref="delete_item">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br/>
                    <button
                        @click="deleteCustomerData"
                        class="btn btn-success"
                        type="button">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button
                        @click="hideModalDelete"
                        class="btn btn-outline-secondary"
                        type="button">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal">
            </loading>
        </b-modal>
        <!--        <pre class="alert-primary">{{test_data}}</pre>-->
        <!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import HeaderTitle from "../../HeaderTitle";
import InputGroup from "bootstrap-vue/es/components/input-group/input-group";
import CustomerAddressTax from "./CustomerAddressTax";
import MaskedInput from 'vue-masked-input'
import {canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "customer-information",
    components: {
        Loading,
        CustomerAddressTax,
        InputGroup,
        HeaderTitle,
        Multiselect,
        MaskedInput
    },
    props: {
        id: {default: null}
    },
    data() {
        return {
            transport_fee: [],
            items: [{
                text: 'รายการลูกหนี้',
                to: {name: 'customer'}
            }, {
                text: 'เพิ่มเติม',
                active: true
            }],
            title: "",
            transport: [],
            status_loading: 1,
            msg: '',
            test_data: null,
            changedIndex: [],
            first_load: true,
        };
    },
    created() {
        this.$store.dispatch('Seller/get');
        this.$store.dispatch("TransportType/setTransportTypes");
        this.$store.dispatch("Customer/getCustomerTransportPrice");
        this.$store.dispatch("Customer/getCustomerTransportForm");
        this.$store.dispatch('Common/setProvince');
        this.$store.dispatch('Customer/setProvince');
        this.$store.dispatch("TransportType/transportTypeAll");
        if (!this.id) {
            this.$store.dispatch('Customer/clearFormData');
        }
        this.changedIndex = [];
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.Customer.CustomerForm;
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            optionTransport: state => {
                return state.TransportType.transportTypeList.filter(data => data.id != 4)
            },
            optionProvince: state => {
                return state.Common.province;
            },
            optionDistricts: state => {
                return state.Common.districts;
            },
            optionSubDistricts: state => {
                return state.Common.sub_districts;
            },
            optionProvinceTaxAddress: state => {
                return state.Customer.provinces_tax;
            },
            optionDistrictTaxAddress: state => {
                return state.Customer.districts_tax;
            },
            optionSubDistrictTaxAddress: state => {
                return state.Customer.sub_districts_tax;
            },
            customer_other: state => {
                return state.Customer.customer_other;
            },
            remove_customer_other: state => {
                return state.Customer.remove_customer_other;
            },
            transport_form: state => {
                return state.Customer.transport_form;
            },
            optionTransportType: state => {
                return state.TransportType.transport_type_all;
            },
            user: state => {
                return state.Auth.user;
            },
            post_code() {
                let zipcode = '';
                if (this.form.district && this.form.sub_district) {
                    zipcode = this.form.sub_district.zipcode;
                    return zipcode;
                } else {
                    return zipcode;
                }
            },
            post_code1() {
                let zipcode = '';
                if (this.form.address_tax_1.district && this.form.address_tax_1.sub_district) {
                    zipcode = this.form.address_tax_1.sub_district.zipcode;
                    return zipcode;
                } else {
                    return zipcode;
                }
            },
            post_code2() {
                let zipcode = '';
                if (this.form.address_tax_2.district && this.form.address_tax_2.sub_district) {
                    zipcode = this.form.address_tax_2.sub_district.zipcode;
                    return zipcode;
                } else {
                    return zipcode;
                }
            },
            post_code3() {
                let zipcode = '';
                if (this.form.address_tax_3.district && this.form.address_tax_3.sub_district) {
                    zipcode = this.form.address_tax_3.sub_district.zipcode;
                    return zipcode;
                } else {
                    return zipcode;
                }
            }
        }),
        newList() {
            if (this.id) {
                if (this.form.transport_customer.length < 1) {
                    return this.optionTransport
                }
                return this.form.transport_customer
            }
            return this.optionTransport
        },
        TransportForm() {
            if (this.id) {
                if (this.form.transport_form.length < 1) {
                    return this.transport_form
                }
                return this.form.transport_form
            }
            return this.transport_form
        },
        clonedItems: function () {
            return JSON.parse(JSON.stringify(this.customer_other))
        },
        clonedItemsString() {
            return JSON.stringify(this.clonedItems);
        }
    },
    watch: {
        clonedItemsString: {
            handler: function(newValue, oldValue) {
                // if (!this.first_load) {
                    const newItems = JSON.parse(newValue);
                    const oldItems = JSON.parse(oldValue);

                    newItems.forEach((item, index) => {
                        if (JSON.stringify(item) !== JSON.stringify(oldItems[index]) &&
                            !this.changedIndex.includes(item.id)) {
                            console.log('changed', item.id);
                            this.changedIndex.push(item.id);
                        }
                    });
                // }
                // if (this.first_load) {
                //     this.first_load = false;
                //     this.changedIndex = [];
                // }
            }
        }
    },
    methods: {
        //Modal
        showModalDelete(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        addCustomerOther() {
            this.$store.dispatch("Customer/addCustomerOther");
        },
        removeCustomerOther(index) {
            this.$store.dispatch("Customer/removeCustomerOther", index);
        },
        deleteCustomerData() {
            this.$store.dispatch("Customer/delete", this.id).then(() => {
                this.hideModalDelete();
                this.goToCustomerList();
                this.$store.dispatch("Customer/setCustomer");
            });
        },
        customLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        // CALL API
        saveCustomerData() {
            if (!this.form.credit_limit) {
                this.form.credit_limit = 0;
            }
            if (!this.form.fixed_rate_status) {
                this.form.fixed_rate_status = ""
            }
            if (!this.form.special_customer) {
                this.form.special_customer = ""
            }
            this.transport_fee = [];
            this.form.transport_form = this.TransportForm;
            const details = this.newList;
            if (details) {
                details.forEach(data => {
                    const detail = {
                        transport_id: data.transport_id ? data.transport_id : data.id,
                        name: data.name,
                        fee: data.fee
                    };
                    this.transport_fee.push(detail);
                });
                this.$store.dispatch('Customer/addShippingTransport', this.transport_fee);
            }
            if (!this.form.sale) {
                alert('กรุณาเลือก sale');
            } else if (!this.form.province) {
                alert('กรุณาเลือกจังหวัด')
            } else if (!this.form.district) {
                alert('กรุณาเลือกเขต /อำเภอ')
            } else if (!this.form.store_name) {
                alert('กรุณากรอกชื่อร้าน')
            } else {
                //address_tax
                if (this.form.have_new_address == 2) { //มีที่อยู่ใหม่
                    if (this.form.address_tax_1) { //ที่อยู่ภาษี 1
                        this.form.address_tax_1.provinces_id = this.form.address_tax_1.province ? this.form.address_tax_1.province.id : '';
                        this.form.address_tax_1.districts_id = this.form.address_tax_1.district ? this.form.address_tax_1.district.id : '';
                        this.form.address_tax_1.sub_districts_id = this.form.address_tax_1.sub_district ? this.form.address_tax_1.sub_district.id : '';
                    }
                    if (this.form.address_tax_2) { //ที่อยู่ภาษี 2
                        // //console.log(2);
                        this.form.address_tax_2.provinces_id = this.form.address_tax_2.province ? this.form.address_tax_2.province.id : '';
                        this.form.address_tax_2.districts_id = this.form.address_tax_2.district ? this.form.address_tax_2.district.id : '';
                        this.form.address_tax_2.sub_districts_id = this.form.address_tax_2.sub_district ? this.form.address_tax_2.sub_district.id : '';
                    }
                    if (this.form.address_tax_3) { //ที่อยู่ภาษี 3
                        // //console.log(3);
                        this.form.address_tax_3.provinces_id = this.form.address_tax_3.province ? this.form.address_tax_3.province.id : '';
                        this.form.address_tax_3.districts_id = this.form.address_tax_3.district ? this.form.address_tax_3.district.id : '';
                        this.form.address_tax_3.sub_districts_id = this.form.address_tax_3.sub_district ? this.form.address_tax_3.sub_district.id : '';
                    }
                } else { //ที่อยู่เก่า
                    this.form.address_tax.tax_number = this.form.tax_number;
                    this.form.address_tax.provinces_id = this.form.province ? this.form.province.id : null;
                    this.form.address_tax.districts_id = this.form.district ? this.form.district.id : null;
                    this.form.address_tax.sub_districts_id = this.form.sub_district ? this.form.sub_district.id : null;
                    this.form.address_tax.address = this.form.address ? this.form.address : null;
                    this.form.address_tax.post_code = this.form.post_code ? this.form.post_code : null;
                }
                let data = {
                    customer_id: this.form.customer_id,
                    first_name: this.form.first_name,
                    last_name: this.form.last_name,
                    store_name: this.form.store_name,
                    address: this.form.address,
                    phone: this.form.phone,
                    phone2: this.form.phone2,
                    phone3: this.form.phone3,
                    email: this.form.email,
                    sale_id: this.form.sale.id,
                    provinces_id: this.form.province ? this.form.province.id : '',
                    districts_id: this.form.district ? this.form.district.id : '',
                    sub_districts_id: this.form.sub_district ? this.form.sub_district.id : '',
                    post_code: this.form.post_code,
                    distance: this.form.distance,
                    credit_limit: this.form.credit_limit,
                    tax_number: this.form.tax_number,
                    have_new_address: this.form.have_new_address,
                    display_address_tax: this.form.display_address_tax,
                    file: this.form.file,
                    fixed_rate_status: this.form.fixed_rate_status,
                    special_customer: this.form.special_customer,
                    transport_form: this.form.transport_form,
                    address_tax: this.form.address_tax,
                    address_tax_1: this.form.address_tax_1,
                    address_tax_2: this.form.address_tax_2,
                    address_tax_3: this.form.address_tax_3,
                    transport_customer: this.form.transport_customer,
                    ban_promotion: this.form.ban_promotion,
                };
                this.test_data = data;
                this.showLoadingModal();
                this.msg = 'กำลังบันทึกข้อมูล กรุณารอสักครู่';
                this.status_loading = 1;
                this.$store.dispatch('Customer/save', {
                    id: this.form.id,
                    data: data,
                }).then(data => {
                    //save customer other
                    let new_arr_other = [];
                    this.changedIndex.forEach(i => {
                        new_arr_other.push(this.customer_other.find(data => data.id === i));
                    })
                    let form = {
                        customer_id: data.id,
                        customer_other: new_arr_other,
                        customer_other_remove: this.remove_customer_other,
                    };
                    this.transport = form;
                    this.$store.dispatch("Customer/saveCustomerOther", form).then(() => {
                        this.showLoadingModal();
                        this.msg = 'บันทึกสำเร็จ';
                        this.status_loading = 2;
                        //     this.goToCustomerList();
                    }).catch(err => {
                        this.showLoadingModal();
                        this.msg = 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                        this.status_loading = 3;
                    });
                }).catch(err => {
                    this.showLoadingModal();
                    this.msg = 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
                    this.status_loading = 3;
                });
            }
        },
        fileUpload: function (event) {
            let input = event.target;
            let file = input.files[0];
            if (file) {
                let formData = new FormData();
                formData.append('file', file);
                this.$store.dispatch("Customer/uploadFileCustomer", formData).then(path_file => {
                    this.form.file = path_file;
                    //console.log(this.form.file)
                })
            }
        },
        goToCustomerList() {
            this.$router.push({name: "customer"});
        },

        //get address
        getDistricts(province) {
            this.form.district = "";
            this.form.sub_district = "";
            if (province) {
                //console.log(province.code);
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.form.district = "";
                this.form.sub_district = ""
            }
        },
        getSubDistricts(districts) {
            this.form.sub_district = "";
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
            } else {
                this.form.sub_districts = ""
            }
        },
        //get tax address
        getDistrictsTax(address_tax_id) {
            if (address_tax_id === 1) {
                this.form.address_tax_1.district = null;
                this.form.address_tax_1.sub_district = null;
                if (this.form.address_tax_1.province) {
                    this.$store.dispatch('Customer/setDistrict', this.form.address_tax_1.province.code);
                } else {
                    this.form.address_tax_1.district = null;
                    this.form.address_tax_1.sub_district = null;
                }
            }
            if (address_tax_id === 2) {
                this.form.address_tax_2.district = null;
                this.form.address_tax_2.sub_district = null;
                if (this.form.address_tax_2.province) {
                    this.$store.dispatch('Customer/setDistrict', this.form.address_tax_2.province.code);
                } else {
                    this.form.address_tax_2.district = null;
                    this.form.address_tax_2.sub_district = null;
                }
            }
            if (address_tax_id === 3) {
                this.form.address_tax_3.district = null;
                this.form.address_tax_3.sub_district = null;
                if (this.form.address_tax_3.province) {
                    this.$store.dispatch('Customer/setDistrict', this.form.address_tax_3.province.code);
                } else {
                    this.form.address_tax_3.district = null;
                    this.form.address_tax_3.sub_district = null;
                }
            }

        },
        getSubDistrictsTax(address_tax_id) {
            if (address_tax_id === 1) {
                this.form.address_tax.sub_district = "";
                if (this.form.address_tax_1.district) {
                    this.$store.dispatch('Customer/setSubDistrict', this.form.address_tax_1.district.district_id);
                } else {
                    this.form.address_tax.sub_district = "";
                }
            }
            if (address_tax_id === 2) {
                this.form.address_tax_2.sub_district = "";
                if (this.form.address_tax_2.district) {
                    this.$store.dispatch('Customer/setSubDistrict', this.form.address_tax_2.district.district_id);
                } else {
                    this.form.address_tax_2.sub_district = "";
                }
            }
            if (address_tax_id === 3) {
                this.form.address_tax_3.sub_district = "";
                if (this.form.address_tax_3.district) {
                    this.$store.dispatch('Customer/setSubDistrict', this.form.address_tax_3.district.district_id);
                } else {
                    this.form.address_tax_3.sub_district = "";
                }
            }
        },
        generateCustomerID() {
            //console.log(this.form.store_name);
            //console.log(this.form.sale);
            if (this.form.store_name && this.form.sale && !this.form.id) {
                let data = {
                    name: this.form.store_name,
                    sale_code: this.form.sale.sale_id
                };
                return this.$store.dispatch("Customer/generateCustomerID", data).then(res => {
                    //console.log(res);
                    this.form.customer_id = res;
                })
            }
        },
        saveUpdateLogData(customer, type) {

        }
    }
};
</script>
<style lang="scss" scoped>
a {
    cursor: pointer;
}

thead {
    background-color: white;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
